export default "__VITE_ASSET__a32927f3__"